import React from 'react'
import { useSearchParams } from 'react-router-dom'

function MiniSort({ onCLick }) {

    const [searchParams, setSearchParams] = useSearchParams()

    const sortByData = [
        {
            title: "Alphabetically, A-Z",
            sort: "title-ascending"
        },
        {
            title: "Alphabetically, Z-A",
            sort: "title-descending"
        },
        {
            title: "Price, low to high",
            sort: "price-ascending"
        },
        {
            title: "Price, high to low",
            sort: "price-descending"
        },
        {
            title: "Date, old to new",
            sort: "created-ascending"
        },
        {
            title: "Date, new to old",
            sort: "created-descending"
        }
    ]

    return (
        <div className='p-4 pb-6'>
            <ul className='space-y-3'>
                {sortByData?.map((sortBy, i) => (
                    <li
                        className={`pb-1 ${searchParams?.get('sort_by') === sortBy.sort ? "underline" : ''}`}
                        key={i}
                        onClick={() => {
                            searchParams.set("sort_by", sortBy.sort)
                            setSearchParams(searchParams)
                            onCLick()
                        }}
                    >
                        {sortBy?.title}
                    </li>
                ))}
            </ul>
        </div>
    )
}

export default MiniSort